import { Component } from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '../../components/ui/button';

export class ReportErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error('Report error:', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="bg-white rounded-xl border border-red-200 p-8 text-center" data-testid="report-error-boundary">
                    <AlertCircle className="w-12 h-12 text-red-400 mx-auto mb-4" />
                    <h3 className="text-lg font-semibold text-slate-900 mb-2">Report Failed to Load</h3>
                    <p className="text-sm text-slate-500 mb-4 max-w-md mx-auto">
                        Something went wrong while rendering this report. This may be due to unexpected data. Please try again.
                    </p>
                    <Button
                        variant="outline"
                        onClick={() => this.setState({ hasError: false, error: null })}
                        data-testid="report-error-retry"
                    >
                        <RefreshCw className="w-4 h-4 mr-2" /> Try Again
                    </Button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ReportErrorBoundary;
